import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { Classes, Dialog, Button, Intent } from '@blueprintjs/core'
import get from 'lodash/get'

import { RemoveBlockDialogModel, removeBlockDialogModel } from './model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { SECTION_TYPES_VALUES } from '@client/components/Section/constants'

import './styles.scss'

export class RemoveBlockDialog extends Component {
  static propTypes = {
    app: PropTypes.instanceOf(AppModel),
    model: PropTypes.instanceOf(RemoveBlockDialogModel),
    usePortal: PropTypes.bool,
  }

  static defaultProps = {
    app: AppModelNULL,
    model: removeBlockDialogModel,
    usePortal: true,
  }

  handleClose = () => {
    const { model } = this.props
    model.hideDialog()
  }

  handeSave = async () => {
    const { model } = this.props
    await model.remove()
  }

  render() {
    const { model, app, usePortal } = this.props
    const { formatMessage } = app
    const contentType =
      SECTION_TYPES_VALUES.indexOf(get(model, 'block.type')) !== -1
        ? formatMessage('modal.common.contentType.section')
        : formatMessage('modal.common.contentType.block')
    return (
      <If condition={model.show}>
        <Dialog
          className="save-as-block-dialog"
          isOpen={model.show}
          onClose={this.handleClose}
          title={formatMessage('modal.removeBlock.headerTitle', {
            content_type: contentType,
          })}
          usePortal={usePortal}
        >
          {/* A failed delete keeps the confirmation, with the error under it,
              so the user can retry (FE-1489). */}
          {!model.saved && (
            <div className={Classes.DIALOG_BODY}>
              <p>
                {formatMessage('modal.removeBlock.formDescription', {
                  content_type: contentType,
                  name: get(model, 'block.name'),
                })}
              </p>
              {model.error && (
                <p className="template-saved-error" role="alert">
                  {formatMessage('modal.removeBlock.errorMsg', {
                    content_type: contentType,
                  })}
                </p>
              )}
            </div>
          )}
          {model.saved && (
            <div className={Classes.DIALOG_BODY}>
              <p className="template-saved-success bp6-ui-text bp6-ui-text-large">
                {formatMessage('modal.removeBlock.savedMsg', {
                  content_type: (
                    <span key="1" style={{ textTransform: 'capitalize' }}>
                      {contentType}
                    </span>
                  ),
                })}
              </p>
            </div>
          )}
          <div className="bp6-dialog-footer">
            <div className="bp6-dialog-footer-actions">
              {!model.saved && (
                <Button
                  text={formatMessage('modal.common.cancelBtn')}
                  onClick={this.handleClose}
                  disabled={model.saving}
                />
              )}
              {!model.saved && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handeSave}
                  text={formatMessage('modal.removeBlock.saveTemplateBtn', {
                    content_type: contentType,
                  })}
                  loading={model.saving}
                  disabled={model.saving}
                />
              )}
              {model.saved && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handleClose}
                  text={formatMessage('modal.common.continurEditingBtn')}
                />
              )}
            </div>
          </div>
        </Dialog>
      </If>
    )
  }
}

export default inject('app')(observer(RemoveBlockDialog))
